"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon element-link", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h26v26H1z" }),
            _react2.default.createElement("path", { d: "M28 27l-1 1v-1h1zM1 27h26V1H1v26zM0 0h28v28H0V0z", fill: "#A5A5A5" }),
            _react2.default.createElement(
                "g",
                { fill: "#333" },
                _react2.default.createElement("path", { d: "M13.617 14.764c-.894-.82-.88-2.028 0-2.838l2.773-2.8c.967-1.113 2.47-1.36 3.382-.436.886.897.584 2.31-.535 3.281l-1.72 1.661a.5.5 0 1 0 .695.72l1.7-1.644c1.488-1.29 1.928-3.347.572-4.72-1.37-1.387-3.534-1.032-4.827.458l-2.733 2.76c-1.292 1.187-1.313 3.076.018 4.295a.5.5 0 0 0 .675-.737z" }),
                _react2.default.createElement("path", { d: "M14.777 13.642c.895.82.882 2.028 0 2.838l-2.756 2.807c-.966 1.111-2.47 1.358-3.381.434-.886-.896-.584-2.309.535-3.28l1.72-1.66a.5.5 0 0 0-.696-.72l-1.7 1.643c-1.488 1.29-1.927 3.347-.57 4.72 1.368 1.386 3.533 1.031 4.826-.459l2.717-2.766c1.291-1.186 1.311-3.075-.02-4.294a.5.5 0 1 0-.675.737z" })
            )
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/element-link.js
// module id = 1863
// module chunks = 0